<template>
  <div class="cam-host">
    <div class="m-wrap">
      <div class="m-hero">
        <img class="m-bg" :src="bgSrc" alt="" />

        <!-- Title -->
        <div class="m-title">
          <div class="m-title__line1">{{ $t('Cambodia') }}</div>
          <div class="m-title__line2">{{ $t('Cockfight Rules') }}</div>
        </div>

        <!-- Automatic loss -->
        <div class="m-row m-row--auto">
          <div class="m-row__text">
            <div class="m-row__small">{{ $t('Touching or Catching =') }}</div>
            <div class="m-row__big">{{ $t('Automatic Loss') }}</div>
          </div>
          <img class="m-row__icon" :src="noCatchSrc" alt="" />
        </div>

        <!-- No External Help -->
        <div class="m-strip m-strip--red">
          <img class="m-strip__icon m-strip__icon--left" :src="noExternalHelpSrc" alt="" />
          <div class="m-strip__content">
            <div class="m-strip__title">{{ $t('No External Help') }}</div>
            <div class="m-strip__desc">
              <div>{{ $t('No fixing, No beak adjustment') }}</div>
              <div>{{ $t('No water') }}</div>
            </div>
          </div>
        </div>

        <!-- Defeated if -->
        <div class="m-strip m-strip--blue">
          <div class="m-strip__content m-strip__content--left">
            <div class="m-strip__title m-strip__title--left">{{ $t('Defeated if') }}</div>

            <ul class="m-list">
              <li class="m-list__item">
                <img class="m-bullet" :src="checkBulletSrc" alt="" />
                <span>{{ $t('Lies Flat') }}</span>
              </li>
              <li class="m-list__item">
                <img class="m-bullet" :src="checkBulletSrc" alt="" />
                <span>{{ $t('Runs Away / Cries') }}</span>
              </li>
              <li class="m-list__item">
                <img class="m-bullet" :src="checkBulletSrc" alt="" />
                <span>{{ $t('No Retaliation × 3') }}</span>
              </li>
            </ul>

            <div class="m-note">
              {{ $t('Standing beats Kneeling;') }}<br />
              {{ $t('Kneeling beats Lying Flat') }}
            </div>
          </div>

          <img class="m-strip__icon m-strip__icon--right" :src="defeatedSrc" alt="" />
        </div>

        <!-- Bottom warning -->
        <div class="m-strip m-strip--bottom">
          <img class="m-warn" :src="warnSrc" alt="" />
          <div class="m-bottom-text">{{ $t('NO ABUSED or POISONING ALLOWED') }}</div>
        </div>

        <!-- Footnote -->
        <div class="m-footnote">{{ $t('*Arena Judge decision is final.') }}</div>
      </div>
    </div>
  </div>
</template>


<script>

    export default {
        name: 'CamRules',
        data() {
            return {
                bgSrc: require('@/assets/images/game-help/cambodia-bg-mobile.webp'),
                noCatchSrc: require('@/assets/images/game-help/ccf-1.webp'),
                noExternalHelpSrc: require('@/assets/images/game-help/ccf-2.webp'),
                defeatedSrc: require('@/assets/images/game-help/ccf-3.webp'),
                warnSrc: require('@/assets/images/game-help/ccf-4.webp'),
                checkBulletSrc: require('@/assets/svg/game-help/check-bullet.svg'),
            };
        },
    };
</script>

<style lang="scss" scoped>

    .cam-host {
        width: 100%;
        position: relative;
        overflow: visible;
    }

    .text-center {
        text-align: center;
    }

    /* Mobile wrapper */
    .m-wrap {
        width: 100%;
        box-sizing: border-box;
        color: #fff;
    }

    /* Hero */
    .m-hero {
        position: relative;
        width: 100%;
        overflow: hidden;
        aspect-ratio: 215 / 294;
        container-type: inline-size;
    }

    .m-bg {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /* Title overlay */
    .m-title {
        position: absolute;
        top: 7%;
        left: 0;
        right: 0;
        text-align: center;
        text-transform: uppercase;
        text-shadow: 0 6px 18px rgba(0, 0, 0, 0.7);
        z-index: 3;
    }

    .m-title__line1 {
        font-weight: 900;
        letter-spacing: 0.06em;
        font-size: 6.8cqw;
        color: #f2c36b;
        line-height: 1.1;
    }

    .m-title__line2 {
        margin-top: 4px;
        font-weight: 900;
        letter-spacing: 0.1em;
        font-size: 4.2cqw;
        color: rgba(255, 255, 255, 0.95);
        line-height: 1.1;
    }

    .m-row {
        position: absolute;
        left: 3.2cqw;
        right: 3.2cqw;
        display: grid;
        grid-template-columns: 1fr 25.5cqw;
        align-items: center;
        z-index: 3;
        box-shadow: 0 14px 26px rgba(0, 0, 0, 0.35);
    }

    .m-row--auto {
        top: 20%;
        z-index: 0;

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            margin: auto;
            width: 90%;
            height: 90%;
            background-image: linear-gradient(to right, rgba(20, 37, 74, 0.07) 4%, rgba(32, 67, 144, 0.65) 34%, #1b4193 86%);
            border-radius: 10px;
            z-index: -1;
        }
    }

    .m-row__text {
        text-align: center;
        padding-left: 16cqw;
    }

    .m-row__small {
        font-size: 2cqw;
        font-weight: 700;
        color: rgba(239, 221, 181, 0.95);
    }

    .m-row__big {
        margin-top: 4px;
        font-size: 3.2cqw;
        font-weight: 900;
        letter-spacing: 0.06em;
        color: #ffda3c;
        text-transform: uppercase;
    }

    .m-row__icon {
        width: 25.5cqw !important;
        height: auto !important;
        justify-self: end;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.35));
    }

    /* Strips */
    .m-strip {
        position: absolute;
        left: 3.2cqw;
        right: 3.2cqw;
        z-index: 3;
        box-shadow: 0 14px 26px rgba(0, 0, 0, 0.35);
        overflow: hidden;
    }

    /* Red strip */
    .m-strip--red {
        top: 35%;
        display: grid;
        grid-template-columns: 28cqw 1fr;
        gap: 10px;
        align-items: center;
        z-index: 0;

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            margin: auto;
            width: 80%;
            height: 90%;
            background-image: linear-gradient(to right, #cc2b2b 9%, rgba(111, 26, 26, 0.7) 67%, rgba(36, 13, 13, 0));
            border-radius: 10px;
            z-index: -1;
        }
    }

    .m-strip--blue {
        top: 49%;
        display: grid;
        grid-template-columns: 1fr 36cqw;
        gap: 10px;
        align-items: center;
        z-index: 0;

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            margin: auto;
            width: 80%;
            height: 90%;
            background-image: linear-gradient(to right, rgba(20, 37, 74, 0.07) 4%, rgba(32, 67, 144, 0.65) 34%, #1b4193 86%);
            border-radius: 10px;
            z-index: -1;
        }
    }

    .m-strip__icon--left {
        width: 28cqw !important;
        height: auto !important;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.35));
    }

    .m-strip__icon--right {
        width: 36cqw !important;
        height: auto !important;
        justify-self: end;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.35));
    }

    .m-strip__content {
        text-align: center;
        color: #fff;
        padding-right: 10cqw;

        &--left {
            padding-right: 2cqw;
            padding-left: 12cqw;
            .m-strip__title {
                text-align: left;
            }
        }
    }


    .m-strip__title {
        font-weight: 900;
        letter-spacing: 0.06em;
        font-size: 3cqw;
        color: #ffda3c;
        text-transform: uppercase;
    }

    .m-strip__desc {
        margin-top: 6px;
        font-size: 2cqw;
        line-height: 1.25;
        font-weight: 700;
        opacity: 0.95;
    }

    /* list */
    .m-list {
        list-style: none;
        padding: 0;
        margin: 4px 0 0;
        display: grid;
        gap: 4px;
    }

    .m-list__item {
        display: grid;
        grid-template-columns: 3.6cqw 1fr;
        gap: 8px;
        align-items: center;
        font-size: 2cqw;
        font-weight: 800;
        color: rgba(255, 255, 255, 0.92);
        text-align: left;
    }

    .m-bullet {
        width: 3cqw !important;
        height: 3cqw !important;
    }

    .m-note {
        margin-top: 4px;
        font-size: 1.8cqw;
        font-weight: 900;
        color: #ffda3c;
        opacity: 0.9;
        line-height: 1.2;
        text-align: left;
    }

    /* bottom */
    .m-strip--bottom {
        top: 71%;
        display: grid;
        grid-template-columns: 25cqw 1fr;
        gap: 10px;
        align-items: center;
        z-index: 0;

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            margin: auto;
            width: 80%;
            height: 90%;
            background-image: linear-gradient(to right, #cc2b2b 9%, rgba(111, 26, 26, 0.7) 67%, rgba(36, 13, 13, 0));
            border-radius: 10px;
            z-index: -1;
        }
    }

    .m-warn {
        width: 25cqw !important;
        height: auto !important;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.35));
    }

    .m-bottom-text {
        text-align: center;
        font-weight: 900;
        letter-spacing: 0.06em;
        color: #ffda3c;
        text-transform: uppercase;
        font-size: 3.2cqw;
        line-height: normal;
        padding-right: 10cqw;
    }

    /* footnote */
    .m-footnote {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 7.6cqw;
        text-align: center;
        font-size: 2.8cqw;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.82);
        text-shadow: 0 6px 18px rgba(0, 0, 0, 0.6);
        z-index: 3;
    }

</style>